<template>
  
    <nav-bar  />
  
    <main-container>
  
      <template v-slot>          
    
      <list-group class="py-2" v-if="schedulings.length > 0">
        <list-item v-for="obj in schedulings" :key="obj.id">
          <template v-slot:title>
            <h5 class="mb-1 fw-bold">{{ obj.patientName }}</h5>             
          </template>
          <template v-slot:complement>
            <p class="mb-0">{{`${formatSchedulingDate(obj.startDate)}`}}</p>   
            <p class="mb-0">{{`${formatSchedulingTime(obj.startDate, obj.endDate)}`}}</p>
          </template>
        </list-item>
      </list-group>
  
      <list-group class="py-2" v-else>
        <list-item>
          <template v-slot:title>
            <div class="d-flex w-100">
              <h5 class="mb-1 fw-bold">Nenhum agendamento encontrado!</h5>
            </div>
          </template>
        </list-item>
      </list-group>
      </template>    
                  
    </main-container>
  
    <bottom-bar />
  
  
  </template>
  
  <script>
  import {getInstance} from "../../api/api";
  import {formatSchedulingDate, formatSchedulingTime} from "../../services/formatters";
  import {showErrorModal} from "../../services/popups";
  import timeMixins from "../../services/time";
  import { useUserStore } from '../../store/user';
  import { useSchedulingStore } from '../../store/scheduling';
  const api = getInstance();
  
  export default {
      name:"MySchedulingsListView",
      mixins:[ timeMixins],
      inject:["mySpinner"],
      setup() {
        const userStore = useUserStore();
        const schedulingStore = useSchedulingStore()
  
        return { userStore, schedulingStore }
      },
      async mounted() {  
        await this.getMySchedulings();
      },
      data() {
        return {
          schedulings:[],          
        }
      },
      methods: {       
        async getMySchedulings() {
          this.mySpinner.loading = true;
  
          try {
            let response = await api.get("v1/Scheduling/My");
  
            this.mySpinner.loading = false;          
  
            if (!response.data.success) {              
              this.schedulings = [];
            }
            else {
              this.schedulings = response.data.data;
              this.schedulings.sort((a, b) => (b.startDate > a.startDate) ? 1 : ((a.startDate > b.startDate) ? -1 : 0));
            }          
          } catch {
            this.mySpinner.loading = false;
            showErrorModal("Erro ao conectar-se ao servidor!");
          } 
  
        },                      
        formatSchedulingTime,
        formatSchedulingDate  
    },      
  }
  
  </script>
  
  
  <style lang="css" scoped>
      @import'../../assets/css/_colors';
      @import'../../assets/css/_schedulings';
  </style>
  